/**
 * Selain-helpereitä: leikepöytä + tiedostonlataus.
 *
 * Iframe-esikatselut (kuten Emergent preview) estävät usein clipboard API:n
 * Permissions-Policyllä. Tarjoamme robustin fallbackin: kopioi DOM-tempun
 * kautta tai jätä käyttäjä kopioimaan käsin.
 */

/** Kopioi tekstiä leikepöydälle. Palauttaa true jos onnistuu. */
export async function copyToClipboard(text) {
  try {
    if (navigator.clipboard && window.isSecureContext) {
      await navigator.clipboard.writeText(text);
      return true;
    }
  } catch {
    // fallthrough
  }
  // Fallback: execCommand("copy")
  try {
    const ta = document.createElement("textarea");
    ta.value = text;
    ta.style.position = "fixed";
    ta.style.top = "-1000px";
    ta.style.opacity = "0";
    document.body.appendChild(ta);
    ta.focus();
    ta.select();
    const ok = document.execCommand("copy");
    document.body.removeChild(ta);
    return ok;
  } catch {
    return false;
  }
}

/** Lataa Blob-tiedosto käyttäjälle robustisti (toimii kaikissa selaimissa). */
export function downloadBlob(blob, filename) {
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename || "lataus.bin";
  a.rel = "noopener";
  a.style.display = "none";
  document.body.appendChild(a);
  a.click();
  // Anna selaimen aloittaa lataus ennen URL:n vapautusta
  setTimeout(() => {
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  }, 1000);
}
